class ScrollObserver {
  defaultOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0,
    once: true
  }
  constructor(elms, cb, options) {
    this.DOM = {
      elms: document.querySelectorAll(elms)
    };
    this.cb = cb;
    this.options = { ...this.defaultOptions, ...options };
    this.once = this.options.once;
    this.#init();
  }
  #init() {
    const callback = function(entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.cb(entry.target, true);
          if (this.once) observer.unobserve(entry.target);
        } else {
          this.cb(entry.target, false)
        }
      });
    };
    this.io = new IntersectionObserver(callback.bind(this), this.options);
    this.io.POLL_INTERVAL = 100;
    this.DOM.elms.forEach(elm => this.io.observe(elm));// 監視を開始
  }
  disconnect() {
    this.io.disconnect();// 監視を停止
  }
}
export default ScrollObserver;